import React, { useState } from "react";
import MainLayoutWithoutFooter from "../components/MainLayoutWithoutFooter";
import PrintersPanel from "../components/hardware/PrintersPanel";
import FailedPrintsPanel from "../components/failedprints/FailedPrintsPanel";
import AppsPanel from "../components/hardware/AppsPanel";
import KdsPanel from "../components/hardware/KdsPanel";
import ArticlesPanel from "../components/hardware/ArticlesPanel";
import "../styles/hardwarePage.css";

const SECTIONS = [
  {
    key: "printers",
    label: "Printers",
    description:
      "Receipt and kitchen docket printers connected to this restaurant. Print jobs (orders, reservations, bookings reports) are routed to whichever printer is set as primary.",
  },
  {
    key: "failedPrints",
    label: "Failed Prints",
    description:
      "Dockets that did not reach a printer, with a plain-English reason, the order, and the printer involved.",
  },
  {
    key: "apps",
    label: "Apps",
    description:
      "Companion apps used alongside this POS — staff ordering, kitchen display, and reporting apps.",
  },
  {
    key: "countertopPos",
    label: "Countertop POS",
    description:
      "The fixed front-of-house terminal used for taking orders, processing payments, and managing the floor plan.",
  },
  {
    key: "tablets",
    label: "Tablets",
    description:
      "Handheld tablets for tableside ordering and payments, kept in sync with the main POS in real time.",
  },
  {
    key: "kds",
    label: "Kitchen Display Systems",
    description:
      "Screens in the kitchen that replace paper dockets, showing incoming orders and their prep status.",
  },
  {
    key: "articles",
    label: "Articles",
    description:
      "Setup guides and troubleshooting articles for the hardware above.",
  },
];

const HardwarePage = () => {
  const [activeSection, setActiveSection] = useState(SECTIONS[0].key);
  const active = SECTIONS.find((s) => s.key === activeSection);

  return (
    <MainLayoutWithoutFooter>
      <div className="pageContent reservationsPage pb-2">
        <div className="container">
          <h2 className="lgTitle mb-3">Hardware</h2>

          <div className="tabStyle" id="hardwareTab" role="tablist">
            <div className="hardwareTabBar">
              {SECTIONS.map((section) => (
                <button
                  key={section.key}
                  type="button"
                  className={`hardwareTabBtn ${activeSection === section.key ? "active" : ""}`}
                  role="tab"
                  aria-selected={activeSection === section.key}
                  onClick={() => setActiveSection(section.key)}
                >
                  {section.label}
                </button>
              ))}
            </div>

            <div className="tab-content">
              <div className="tab-pane fade show active" role="tabpanel">
                {activeSection === "printers" ? (
                  <PrintersPanel />
                ) : activeSection === "failedPrints" ? (
                  <FailedPrintsPanel />
                ) : activeSection === "apps" ? (
                  <AppsPanel />
                ) : activeSection === "kds" ? (
                  <KdsPanel description={active.description} />
                ) : activeSection === "articles" ? (
                  <ArticlesPanel />
                ) : (
                  <div className="cardStyle p-4">
                    <h4 className="mb-3">{active.label}</h4>
                    <p style={{ opacity: 0.85, maxWidth: "640px" }}>{active.description}</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </MainLayoutWithoutFooter>
  );
};

export default HardwarePage;
